import moment from 'moment-timezone'

export default (value, withSeconds = true) => {
  moment.locale(import.meta.env.VITE_COUNTRY)

  if (value) {
    let format = 'DD-MM-YYYY' + ' HH:mm:ss'
    if (withSeconds === false) {
      format = 'DD-MM-YYYY' + ' HH:mm'
    }
    const date = moment(value)
      .tz(import.meta.env.VITE_TIMEZONE || 'Europe/Istanbul')
      .format(format)
    return date !== 'Invalid datetime' ? date : '-'
  }

  return '-'
}
